class ApiSuno {

    getRentabilidade(rentabilidadeId, success, error){
        return this.request(
            `api/Indexer/value?name=${rentabilidadeId}`,
            "GET",
            null,
            success,
            error
            )
    }

    getIpca(success, error){
        return this.request(
            `api/Indexer/value`,
            "GET",
            null,
            success,
            error
            )
    }

    // Função responsável por realizar os requests na API com os parametros informados
    request(url, method, body, success, error){
        const axios = require('axios');
        let headers = {}
        headers['Content-Type'] = 'application/json'
        headers['partner_token'] = '0d3befdd-a7b7-4439-9e2d-57f6eddf302a';

        let config = {
            url: url,
            method: method,
            baseURL: 'https://api.statusinvest.com.br/',
            headers: headers,
            responseType: 'json',
        }

        if(method !== 'GET' && method !== 'DELETE')
        config['data'] = body

        axios.request(config)
        .then((responseSuccess) => {
        return success(responseSuccess)
        })
        .catch((responseError) => {
        return error(responseError)
        })
    }
}
export default ApiSuno